import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'

const ACHContractDialog = ({ url, onClose }) => {
  if (!url) {
    return null
  }

  return (
    <ConfirmationDialog maxWidth={850} hasConfirmButton={false} onClose={onClose}>
      <div
        style={{
          width: 600
        }}
      >
        <iframe
          title="ACH contract"
          src={`${url}?embedded=true&redirect_iframe=false`}
          style={{
            width: '100%',
            height: '900px'
          }}
        ></iframe>
      </div>
    </ConfirmationDialog>
  )
}

export default ACHContractDialog
